
import {DataForm} from 'argo-js/src/view';
import {Utils} from 'argo-js/src/common/Utils';
import {Request} from 'argo-js/src/data';

const RESET_PARAM = 'pid';

export class PwReset extends DataForm {

  constructor(config) {
    super($.extend({
      autoInit: false,
      ui: {
        hasResetId: '.has-reset-id',
        emptyResetId: '.empty-reset-id',
        statusMessage: '.status-message',
        successText: '.alert-success'
      },
      errorMap: {
        NOT_FOUND: {
          message: 'pwreset.error.NOT_FOUND'
        },
        PASSWORD_DOES_NOT_MATCH_RULES: {
          name: 'password',
          message: 'error.PASSWORD_DOES_NOT_MATCH_RULES'
        },
        NO_SUCH_USERNAME_OR_EMAIL: {
          name: 'email',
          message: 'pwreset.error.NO_SUCH_USERNAME_OR_EMAIL'
        },
        TERMS_AND_CONDITIONS_MUST_BE_ACCEPTED: {
          message: 'error.TERMS_AND_CONDITIONS_MUST_BE_ACCEPTED'
        },
        MESSAGE_COULD_NOT_BE_SENT: {
          message: 'error.MESSAGE_COULD_NOT_BE_SENT'
        }
      },
    }, config));

    let params = Utils.getQueryParams();
    this.hasResetId = Object.prototype.hasOwnProperty.call(params, RESET_PARAM);
    this.resetId = this.hasResetId ? params[RESET_PARAM] : null;

    this.init();
  }

  init() {
    super.init();
    this.ui.hasResetId.toggle(this.hasResetId);
    this.ui.emptyResetId.toggle(!this.hasResetId);
    this.el.fadeIn();
  }

  onSubmit(data) {

    // reset password with reset ID
    if (this.hasResetId) {
      return this.app.user.changePasswordByToken(this.resetId, data.password);
    }
    // request reset password mail by email
    if (data.email.indexOf('/') === -1) {
      return this.app.user.sendResetPasswordLink(data.email);
    }

    let spits = data.email.split('/');
    let pdata = {
      tenant: { name: spits.shift() },
      name: spits.join('/')
    };

    // request by tenant and user name
    return new Request({collection: 'users'})
      .post('resetPassword', pdata);
  }

  onSuccess() {
    this.ui.successText.text(this.t(this.hasResetId ? 'pwreset.success.changepw' : 'pwreset.success.mail'));
    this.ui.form.hide();
    this.ui.statusMessage.fadeIn(500);
  }

  onBeforeError(resp) {
    if (resp.errCode === 'NOT_FOUND' || resp.status === 404) {
      this.setFormError(this.t(this.config.errorMap.NOT_FOUND.message));
      return false;
    }
  }
}

